import React from 'react';

function SubmissionGuidelines() {
  return (
    <div className="container py-5">
      <h2 className="mb-4 text-center fw-bold">Submission Guidelines</h2>
      <div className="mb-4">
        <h4>Formatting Your Manuscript</h4>
        <ul>
          <li>Use the <b>Manuscript Template</b> provided on our Resources page.</li>
          <li>Include a title page, abstract, keywords, and references.</li>
          <li>Follow standard scientific structure: Introduction, Methods, Results, Discussion, Conclusion.</li>
        </ul>
      </div>
      <div className="mb-4">
        <h4>Required Documents</h4>
        <ul>
          <li>Manuscript file (Word or PDF)</li>
          <li>Copyright Transfer Form</li>
          <li>Conflict of Interest Disclosure</li>
        </ul>
      </div>
      <div className="mb-4">
        <h4>Submission Process</h4>
        <ol>
          <li>Prepare your manuscript and required documents.</li>
          <li>Submit via the <a href="/submit">online portal</a>.</li>
          <li>Track your submission status through your account dashboard.</li>
        </ol>
      </div>
      <div className="alert alert-info">For questions, contact <a href="mailto:drsyedrizwanabbas@gmail.com">drsyedrizwanabbas@gmail.com</a> or call 03444244544.</div>
    </div>
  );
}

export default SubmissionGuidelines; 